import { render, staticRenderFns } from "./TaskAppFullInfo.vue?vue&type=template&id=42828207&scoped=true&lang=pug&"
import script from "./TaskAppFullInfo.vue?vue&type=script&lang=js&"
export * from "./TaskAppFullInfo.vue?vue&type=script&lang=js&"
import style0 from "./TaskAppFullInfo.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TaskAppFullInfo.vue?vue&type=style&index=1&id=42828207&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42828207",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VDialog,VIcon,VRow})
